import { useExamEventDetails } from '@exam-center/exam-event-management';
import { RegistrationStatus } from '@exam-center/graphql';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { useHasPermission } from '@shared/permissions';

import { ExamEventDetailsStatusLogic } from '../exam-event-details-status-logic';
import { ExamEventReadonlyDetails } from '../exam-event-readonly-details';
import { ExamEventTemporarilyClosedLogic } from '../exam-event-temporarily-closed-logic';

export default function ExamEventDetails() {
  const canEdit = useHasPermission(APP_PERMISSIONS.EXAM_EVENT_MANAGEMENT.EXAM_EVENT.UPDATE);
  const { examEvent } = useExamEventDetails();
  const examEventStatus = examEvent.registrationStatus;

  if (!canEdit) return <ExamEventReadonlyDetails />;

  switch (examEventStatus) {
    case RegistrationStatus.Scheduled:
    case RegistrationStatus.OpenForRegistration:
    case RegistrationStatus.RegistrationClosed:
    case RegistrationStatus.SessionFull:
      return <ExamEventDetailsStatusLogic />;
    case RegistrationStatus.Canceled:
      return <ExamEventReadonlyDetails />;
    case RegistrationStatus.TemporarilyClosed:
      return <ExamEventTemporarilyClosedLogic />;
    default:
      return null;
  }
}
